import React from 'react';
import styled, { css } from 'styled-components';
import {
    getLogoPrice,
    stringContainsPrice,
} from '../../../../acquisition/components/CategoryPage/LogoDesignPricing/helpers';
import { CurrencyRange } from '../../../../acquisition/components/I18n/CurrencyRange';
import Plus2 from '../../Icon/components/Plus2';
import Minus2 from '../../Icon/components/Minus2';
import Heading from '../../Heading';
import { colors, spaces } from '../../../lib/styles';
import getHighContrastTextColor from '../../../lib/getHighContrastTextColor';
import { useSite } from '../../../lib/site';
import { Currency } from '../../../lib/currency';
import BaseAccordionItem, { AccordionItemValue } from './BaseAccordionItem';
import { ControlsIcon } from './ControlsIcon';

export const Wrapper = styled.div<{ isOpen: boolean; featureColor?: string }>(
    ({ isOpen, featureColor }) =>
        css`
            color: ${colors.typography.root};
            background: ${isOpen && featureColor ? featureColor : colors.grey100};
            border-radius: ${spaces.space5}px;
            border: none;
            padding-left: ${spaces.space8}px;
            padding-right: ${spaces.space8}px;
            padding-bottom: ${isOpen ? `${spaces.space8}px` : 0};

            ${featureColor &&
            isOpen &&
            css`
                background: ${featureColor};
                color: ${getHighContrastTextColor(featureColor)};
                transition: background 0.3s;
            `}

            ${featureColor &&
            !isOpen &&
            css`
                transition: all 0.3s;
            `}
        `
);

interface Props {
    id: string;
    title: string;
    isOpen?: boolean;
    isLast?: boolean;
    featureColor?: string;
    children: React.ReactNode;
    onOpen?: (accordionItemValue: AccordionItemValue) => void;
    onClick?: () => void;
}

export const ButtonAccordionItem = ({
    title,
    isOpen = false,
    isLast = false,
    featureColor,
    ...props
}: Props) => {
    const color = isOpen ? featureColor : colors.grey100;
    const site = useSite();
    const currency = site.siteConfig.currency as Currency;

    const heading = stringContainsPrice(title) ? (
        <CurrencyRange
            string={title}
            fromPriceValue={getLogoPrice('base-option', currency)}
            toPriceValue={getLogoPrice('platinum-option', currency)}
            currency={currency}
            hideDecimal
        />
    ) : (
        title
    );

    return (
        <Wrapper data-testid="accordion-item" isOpen={isOpen} featureColor={color}>
            <BaseAccordionItem
                {...props}
                title={title}
                isOpen={isOpen}
                featureColor={color}
                triggerContent={
                    <>
                        <Heading type="h3" variations={['h5', 'no-margin']}>
                            {heading}
                        </Heading>
                        <ControlsIcon isOpen={Boolean(isOpen)} featureColor={color}>
                            {isOpen ? <Minus2 /> : <Plus2 />}
                        </ControlsIcon>
                    </>
                }
            />
        </Wrapper>
    );
};
